import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({ baseURL: BACKEND_URL, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let redirectedAfterExpiredSession = false;
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && !redirectedAfterExpiredSession) {
      redirectedAfterExpiredSession = true;
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('firstAccess');
      localStorage.removeItem('cliente');
      window.location.assign('/');
    }
    return Promise.reject(error);
  }
);

export const getPortfolio   = ()         => api.get('/api/portfolio').then(r => r.data);
export const addPosition    = (data)     => api.post('/api/portfolio', data).then(r => r.data);
export const addKairiPosition = (data)   => api.post('/api/portfolio/kairi', data).then(r => r.data);
export const removePosition = (id)       => api.delete(`/api/portfolio/${id}`).then(r => r.data);
export const updatePosition = (id, data) => api.patch(`/api/portfolio/${id}`, data).then(r => r.data);
export const closePosition  = (id, data) => api.patch(`/api/portfolio/${id}/close`, data).then(r => r.data);
export const getPortfolioEquity = (range = 'current_month', strategy = 'all') => api.get('/api/portfolio/equity', {
  params: {
    range,
    ...(strategy && strategy !== 'all' ? { strategy } : {}),
  },
}).then(r => r.data);
export const getRiskSettings = () => api.get('/api/risk/settings').then(r => r.data);
export const updateRiskSettings = (data) => api.put('/api/risk/settings', data).then(r => r.data);
export const getRiskSummary = () => api.get('/api/risk/summary').then(r => r.data);
